<template>
  <div class="Locations botPage">
    <mbHeader :title="$t('afm_locations')" :left="true" :lang="true"></mbHeader>
<!--    <div class="img">-->
<!--      <img src="../assets/img/afmLocation.png"/>-->
<!--    </div>-->
<!--    <div class="info">-->
<!--      <div class="title">{{ $t('location_upper')}}</div>-->
<!--      <div class="text1">1. Bellevue AFM 14515 NE 20th St, Bellevue WA 98007</div>-->
<!--      <div class="text1">2. Seattle AFM 13200 Aurora Ave N, Seattle WA 98133</div>-->
<!--      <div class="text1">3. Oregon AFC 3849 SW 117th Ave, Beaverton WA 97005</div>-->
<!--    </div>-->
    <location></location>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import location from '../Profile/location';
export default {
  name: "mobileLocations",
  components: {mbHeader,location},
}
</script>

<style scoped lang="less">
.Locations {
  min-height: 100vh;
  padding: 66px 16px 16px;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileLocations.vue